// Native <video> with controls — works for the Firebase Storage signed URLs
// the iOS app writes. We don't autoplay (mobile browsers block it without
// user gesture anyway) and we use `playsInline` so iOS Safari plays inline
// instead of going fullscreen on tap.

interface Props {
  src: string;
}

export function VideoPlayer({ src }: Props) {
  return (
    <section aria-label="Video" className="w-full">
      <video
        src={src}
        controls
        playsInline
        preload="metadata"
        className="w-full max-h-[70vh] bg-black rounded-md"
      />
    </section>
  );
}
